import forwardToURL from '../../../utils/forwardToURL';
import Track from '../../../utils/tracking';
import {sendNewpayResponse} from '../../APIActions/CheckoutAPIActions';

const updateNewpayStatus = (status, dispatch, stopWithError) => {
  try {
    dispatch(sendNewpayResponse(status))
      .then((response) => {
        if (response && (response.status === 200 || response.status === 202)) {
          forwardToURL('/checkout/processing');
        } else {
          stopWithError();
          Track.error(`Error sending Newpay action response to Checkout API: response: ${JSON.stringify(response)}`);
        }
      }).catch((error) => {
        stopWithError();
        Track.error(`Error sending success request to return-from-hosted ${error}`);
      });
  } catch (error) {
    stopWithError();
    Track.error(`Error sending Newpay action response to Checkout API: response: ${error}`);
  }
};

export default updateNewpayStatus;
